

function Felhasznalasi() {


    return (

        <>
            <section>

                <h1>Felhasználási feltételek</h1>

                <p>Köszönjük, hogy használod az online gépi fordító oldalunkat! Az alábbiakban megtalálod a felhasználási feltételeket, amelyek betartása fontos a zavartalan és biztonságos használat érdekében. A felhasználási feltételek elfogadásával hozzáférésed van az oldalunkhoz és szolgáltatásainkhoz.</p>

                <h2>Felhasználói felelősségvállalás</h2>
                <ul>
                    <li>a. Az oldal használata során felelősséggel tartozol az általad beküldött szövegek és az ezekkel kapcsolatos tevékenységekért.</li>
                    <li>b. Nem küldhetsz vagy használhatsz olyan tartalmat, amely sérti a szerzői jogokat, védett vagy jogosulatlan tartalmakat, trágár vagy törvénytelen anyagokat.</li>
                    <li>c. Tilos az oldalunkon végzett tevékenységek során más felhasználók zaklatása, fenyegetése vagy bármilyen módon mások jogait megsértése.</li>
                </ul>


                <h2>Intellektuális tulajdonjogok</h2>
                <ul>
                    <li>a. Az oldalunkon található minden tartalom (beleértve a szoftvert, logókat, grafikákat stb.) az intellektuális tulajdonjogok védelme alatt áll, és a szerzői jogokkal védett.</li>
                    <li>b. Semmilyen módon nem jogosult vagy felhatalmazott az oldalunk tartalmának másolására, terjesztésére, módosítására vagy harmadik fél számára történő felhasználására.</li>
                </ul>

                <h2>Adatvédelem</h2>
                <ul>
                    <li>a. Az általad beküldött szövegek és személyes adatok védelme kiemelten fontos számunkra. Az adatvédelmi irányelveink részletesen leírják, hogy milyen módon kezeljük és védelmezzük az általad megadott információkat.</li>
                </ul>
                <h2>Szolgáltatásminőség</h2>
                <ul>

                    <li>a. Az oldalunkon található gépi fordító szolgáltatásokat folyamatosan fejlesztjük és javítjuk, de nem garantáljuk a 100%-os pontosságot vagy hibamentes működést. Az általad beküldött fordításokért vagy azok következményeiért nem vállalunk felelősséget.</li>


                </ul>


                <h2>Felelősségkorlátozás</h2>

                <ul>
                    <li>a. Az oldalunk használata kizárólag a saját felelősségedre történik. Semmilyen körülmények között nem vagyunk felelősek a közvetlen, közvetett, mellékes vagy következményes károkért, amelyek az oldalunk használatából vagy használatával kapcsolatosak.</li>
                </ul>


                <h2>Felhasználási korlátozások</h2>


                <ul>
                    <il>a. Az oldalunkat nem használhatod jogellenes vagy törvénytelen tevékenységek végrehajtására, például spam küldésére, vírusok terjesztésére vagy más felhasználók zaklatására.</il>
                </ul>


                <p style={{marginTop: "1em"}}>Az oldalunk használatával elfogadod és kötelező érvényűnek ismered el a fent felsorolt felhasználási feltételeket. Ha ezeket a feltételeket nem fogadod el vagy megszeged, fenntartjuk a jogot, hogy korlátozzuk vagy megszüntessük az oldalunkhoz való hozzáférésedet.</p>

                <p>Kérjük, olvasd el ezeket a feltételeket gondosan, mielőtt használnád az oldalunkat.</p>


                <h2>Felhasználási javaslat</h2>

                <p>Amikor egy gépi fordítóval szeretnénk szöveget fordítani, érdemes néhány dolgot figyelembe venni. Itt vannak néhány tipikus szempont, amelyek segíthetnek a pontosabb és érthetőbb fordítás elérésében:</p>

                <p><b>Általános érthetőség</b>: Az elsődleges cél az, hogy a fordítás érthető legyen az olvasó számára. Gondoskodjunk arról, hogy a beírt szöveg világos és jól strukturált legyen, hogy a gépi fordító könnyebben megérthesse.</p>

                <p><b>Nyelvtani helyesség</b>: Ügyeljünk arra, hogy a beírt szöveg nyelvtanilag helyes legyen. Egyértelmű mondatokat és pontosan megfogalmazott gondolatokat érdemes használni. Kerüljük a zavaros vagy ambivalens kifejezéseket.</p>

                <p><b>Kifejezések és idiómák</b>: Gépi fordítók gyakran nehézséget okoznak az idiómák, szólások vagy kifejezések megfelelő átültetésében más nyelvre. Ezeket a kifejezéseket célszerű inkább körülírni vagy más, közérthetőbb szavakkal helyettesíteni.</p>

                <p><b>Szakzsargon és specifikus kifejezések</b>: Ha olyan szöveget szeretnénk fordítani, ami szakmai területre vagy specifikus tudásra utal, fontos lehet előzetesen megismerni az adott területen használatos kifejezéseket és szakzsargonokat. Ez segít abban, hogy a fordítás pontosabb és megfelelőbb legyen.</p>

                <p><b>Nyelvi nuanszok és kulturális különbségek</b>: Ne feledkezzünk meg arról, hogy a különböző nyelveknek és kultúráknak eltérő nyelvi nuanszai vannak. Ez befolyásolhatja a fordítás pontos átadását. Ha lehetséges, érdemes olyan fordítószolgálatot választani, amely figyelembe veszi ezeket a kulturális különbségeket.</p>

                <p><b>Ellenőrzés és korrekció</b>: Mindig érdemes ellenőrizni a gépi fordító által generált szöveget. Javítsuk ki a nyelvtani hibákat, értelmetlen fordításokat és egyéb problémákat, hogy a végeredmény pontosabb legyen. Ha lehetséges, kérjünk meg egy anyanyelvi beszélőt is, hogy olvassa át a fordítást és tegyen javaslatokat a pontosításra.</p>

                <p>Emlékezzünk arra, hogy bár a gépi fordítók sokat fejlődtek az elmúlt években, még mindig vannak korlátaik és hibáik. A pontos és természetes fordítás elérése érdekében érdemes odafigyelni ezekre a szempontokra, és szükség esetén további korrekciókat végezni.</p>
            </section>
        </>
    )
}


export default Felhasznalasi